import React from "react";
import PropTypes from "prop-types";
import {ButtonText, ColoredButton} from "BaseComponents/Button";
import {getButtonColor} from "Helpers/ColorHelper";
import {Icon} from "BaseComponents/Icons/Svg";
import {MAINMENU, MOBILEMENU} from "../../framework/consts/menuTypes";
import {useGlobal} from "reactn";
import {MenuButtonWrapper, MenuItemText, MenuItemWrapper} from "../Menu/";

export const HeaderButtonBookATour = ({
                                          ShowButton,
                                          MobileShowInHeader,
                                          Icon: icon,
                                          Link,
                                          FillWithColor,
                                          MenuType,
                                          Depth,
                                          Type
                                      }) => {
    const [theme] = useGlobal("theme");
    const {color, textColor, hoverColor} = getButtonColor("");

    const getButtonIcon = () => {
        switch (icon) {
            case 'calendar-days':
            case 'comment-pen':
            case 'user-lock':
            case 'hands-holding-child':
            case 'building-magnifying-glass':
                return `fa-solid fa-${icon}`;
            case 'user':
                return `fa-light fa-${icon}`;
            case 'key':
            case 'lock-keyhole':
                return `fa-regular fa-${icon}`;
            default:
                return ''
        }
    }

    const getButtonLinkIcon = () => {
        switch (icon) {
            case 'calendar-days':
            case 'comment-pen':
            case 'user-lock':
            case 'hands-holding-child':
            case 'building-magnifying-glass':
                return `fa-solid fa-${icon}`;
            case 'user':
                return `fa-light fa-${icon}`;
            case 'key':
            case 'lock-keyhole':
            case 'speech-bubble':
                return `icon-${icon}`;
            default:
                return ''
        }
    }

    const className = getButtonIcon();
    const classNameLink = getButtonLinkIcon();
    return (
        ShowButton &&
        (MenuType == MOBILEMENU ? (
            (Type === "buttonView" ? (<MenuItemWrapper
                as="div"
                bgColor={theme.colors.lightgrey}
                Depth={Depth}
                MenuType={MAINMENU}
                borderBottom={`1px solid ${theme.colors.grey}`}
                justifyContent="center"
            >
                <ColoredButton
                    href={Link.Url}
                    target={Link.Target ?? "_self"}
                    inverted={FillWithColor}
                    bgColor={color}
                    hoverColor={hoverColor}
                    minWidth="300px"
                    widthsmall="300px"
                    width="300px"
                    color={textColor}
                    margin="0"
                    smallmargin="0"
                    padding="1px 25px"
                    aria-label={Link.Name}
                    importandPadding={true}
                >
                    {icon && <Icon margin="0" className={className}></Icon>}
                    <ButtonText
                        color={textColor}
                        padding="0 0 0 8px"
                        fontWeight="normal"
                        heading={`book a tour`}
                    >
                        {Link.Name}
                    </ButtonText>
                </ColoredButton>
            </MenuItemWrapper>) : (<MenuItemWrapper
                bgColor={theme.colors.lightgrey}
                Depth={Depth}
                MenuType={MAINMENU}
                borderBottom={`1px solid ${theme.colors.grey}`}
                href={Link.Url}
                target={Link.Target ?? "_self"}
            >
                <MenuItemText Color="black" MenuType={MAINMENU} IsExpanded="false">
                    {Link.Name}
                </MenuItemText>
                <MenuButtonWrapper IconSize="23px">
                    <span className="element-link parent-menu-link">
                        <i className={classNameLink} aria-hidden="true"></i>
                    </span>
                </MenuButtonWrapper>
            </MenuItemWrapper>))
        ) : (Type === "buttonView" ? (<ColoredButton
                className="header__button"
                href={Link.Url}
                target={Link.Target ?? "_self"}
                inverted={FillWithColor}
                bgColor={color}
                minWidth="180px"
                width="fit-content"
                color={textColor}
                margin="0"
                smallmargin="0"
                padding="1px 20px"
                aria-label={Link.Name}
                importandPadding={true}
                heightsmall={MobileShowInHeader ? "30px" : "unset"}
            >
                {icon && <Icon margin="0" className={className}></Icon>}
                <ButtonText
                    className={icon ? "only-desktop" : ""}
                    color={textColor}
                    padding="0 0 0 8px"
                    fontWeight="normal"
                    heading={`book a tour`}
                >
                    {Link.Name}
                </ButtonText>
            </ColoredButton>) : (<a className="element-link parent-menu-link "
                                    href={Link.Url}
                                    target={Link.Target ?? "_self"}>
                <i className={classNameLink} aria-hidden="true"></i>
                <span>{Link.Name}</span>
            </a>)
        ))
    );
};

HeaderButtonBookATour.propTypes = {
    ShowButton: PropTypes.bool,
    MobileShowInHeader: PropTypes.bool,
    Icon: PropTypes.string,
    Link: any,
    FillWithColor: PropTypes.bool,
};
